module.exports = __webpack_public_path__ + "assets/img/seal-8c349cd9.png";